import { autoinject, bindable } from "aurelia-framework";
import { transient } from "aurelia-dependency-injection";

@autoinject
@transient()
export class ButtonIcon {

    public constructor() { }

    @bindable
    public icon: string;

    @bindable
    public disabled: boolean;

    @bindable
    public loading: boolean;

    @bindable
    public tab: number;

    attached(): void {
        if (this.disabled) {
            this.tab = -1;
        }
    }

    onClick($event) {
        if (this.disabled) {
            $event.stopPropagation();
        }
    }

    disabledChanged(): void {
        if (this.disabled) {
            this.tab = -1;
        } else {
            this.tab = 0;
        }
    }
}
